import { z } from 'zod';

const toUrl = (input: string): URL | null => {
  try {
    const urlString = /^https?:\/\//i.test(input) ? input : `https://${input}`;
    return new URL(urlString);
  } catch {
    return null;
  }
};

const normalizeDomain = (input: string): string => {
  const url = toUrl(input)!;
  return url.hostname.replace(/^www\./i, '').toLowerCase();
};

export const domainSchema = z
  .string()
  .min(1, 'Domain cannot be empty')
  .trim()
  .refine(
    (val) => {
      const url = toUrl(val);
      if (!url || !/^https?:$/i.test(url.protocol)) {
        return false;
      }
      const domainRegex = /^([a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,}$/i;
      return domainRegex.test(url.hostname);
    },
    {
      message: 'Please enter a valid domain name (e.g., example.com)',
    }
  )
  .transform(normalizeDomain);
